<template>
  <div class="nav" :style=" {backgroundImage:'url('+navBackground+')'}">
    <div class="nav-left nav-menu nav-menu-left">
      <ul>
        <li @click="handleView2" :class="menu.twoClass">今日状况</li>
        <li @click="handleView1" :class="menu.oneClass">全年统计</li>
      </ul>
    </div>
    <div class="nav-title" @click="home" v-html="title"></div>
    <div class="nav-right nav-menu nav-menu-right">
      <ul>
        <li @click="handleView3" :class="menu.threeClass">救援历史</li>
        <li @click="handleView4" :class="menu.fourClass">电梯分布</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navBackground: '../../../static/nav-bg-kb.png',
      menu: {
        oneClass: '',
        twoClass: '',
        threeClass: '',
        fourClass: ''
      },
      cityName: '',
      title: ''
    }
  },
  props: {
    idx: Number
  },
  mounted() {
    this.cityName = sessionStorage.getItem('cityName')
    if(this.cityName == '丹江口市')
      this.title = '十堰市丹江口电梯智慧监管平台'
    else if(this.cityName == '十堰市')
      this.title = '十堰市丹江口电梯智慧监管平台'
    else this.title = this.cityName+'电梯大数据可视化'
    //this.navBackground = this.getTopBackground(cityName)
    switch (this.idx) {
      case 1:
        this.menu.oneClass = 'nav-menu-left-li-active'
        break
      case 2:
        this.menu.twoClass = 'nav-menu-left-li-active'
        break
      case 3:
        this.menu.threeClass = 'nav-menu-right-li-active'
        break
      case 4:
        this.menu.fourClass = 'nav-menu-right-li-active'
        break
    }
  },
  methods: {
    home: function() {
      this.$router.push({ path: '/' })
    },
    handleView1: function(arg) {
      this.$router.push({ path: '/total' })
    },
    handleView2: function(arg) {
      this.$router.push({ path: '/today' })
    },
    handleView3: function(arg) {
      this.$router.push({ path: '/history' })
    },
    handleView4: function(arg) {
      this.$router.push({ path: '/data' })
    },
    getTopBackground: function(name) {
      if (name === '郴州市') {
        return '../../../static/nav-bg-cz.png'
      } else if (name === '阜阳市') {
        return '../../../static/nav-bg-fy.png'
      } else if (name === '临泉县') {
        return '../../../static/nav-bg-lq.png'
      } else if (name === '清远市') {
        return '../../../static/nav-bg-qy.png'
      } else if (name === '太和县') {
        return '../../../static/nav-bg-th.png'
      } else if (name === '重庆市') {
        return '../../../static/nav-bg-cq.png'
      } else if (name === '邵阳市') {
        return '../../../static/nav-bg-sy.png'
      }else {
        return '../../../static/nav-bg-qg.png'
      }
    }
  }
}
</script>
<style>
ul {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0;
}
li {
  list-style: none;
}
.nav {
  width: 100%;
  height: 105px;
  background-size: 100% 100%;
}

.nav > div {
  float: left;
}
.nav .nav-left {
  width: 34%;
  height: 60px;
  margin-top: 40px;
}
.nav .nav-title {
  width: 32%;
  height: 40px;
  margin-top: 15px;
  font-size: 35px;
  font-weight: bold;
  cursor: pointer;
  color: #6ab7ff;
  letter-spacing:5px;
}
.nav .nav-right {
  width: 34%;
  height: 60px;
  margin-top: 40px;
}

.nav .nav-menu > ul > li {
  height: 40px;
  line-height: 40px;
  width: 24%;
  max-width: 200px;
  background: coral;
  margin-top: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #668eff;
  cursor: pointer;
}

.nav .nav-menu > ul > li:hover {
  color: #fff;
}

.nav .nav-menu-left > ul > li {
  float: right;
  background: url('../../../static/menu-l.png') no-repeat;
  background-size: 100% 100%;
}

.nav .nav-menu .nav-menu-left-li-active {
  background: url('../../../static/menu-l-active.png') no-repeat;
  background-size: 100% 100%;
  color: #fff;
}

.nav .nav-menu-right > ul > li {
  float: left;
  background: url('../../../static/menu-r.png') no-repeat;
  background-size: 100% 100%;
}

.nav .nav-menu .nav-menu-right-li-active {
  background: url('../../../static/menu-r-active.png') no-repeat;
  background-size: 100% 100%;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/Nav.vue